import { render } from "./z-modal.vue?vue&type=template&id=5d286bca&scoped=true"
import script from "./z-modal.vue?vue&type=script&lang=js"
export * from "./z-modal.vue?vue&type=script&lang=js"

import "./z-modal.vue?vue&type=style&index=0&id=5d286bca&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d286bca"]])

export default __exports__